import React from 'react';
import {useTranslation} from 'react-i18next';
import {isFieldDiff, isPlainObject} from '../shapes';
import {HIDDEN_FIELDS} from '../labels';
import {
    BU_DIFF_FIELD_ORDER,
    buildChangeCountTitle,
    extraFieldsSummary,
    orderDiffFields,
    resolveDiffCurrency,
} from '../diff_field_types';
import {DiffList, DiffStory} from '../primitives/DiffList';
import {DetailFooter} from '../primitives/DetailFooter';

// Diff PLANO {campo: {before, after}} — BU_EDITED, CLIENT_PROFILE_UPDATED,
// CLIENT_INTEGRATIONS_UPDATED.
//
// Tres decisiones de lectura:
//   · orden canónico (qué línea es → la plata → la configuración), con lo no canónico al final;
//   · la moneda de los montos sale del PROPIO diff (budget_currency) y, si cambió, cada lado
//     va con la suya y sin chip de delta;
//   · con un solo cambio se cuenta como frase, no como lista de una fila.
export function FlatDiffDetail({detail}) {
    const {t} = useTranslation();
    if (!isPlainObject(detail)) return null;

    const {currency, currencyBefore, currencyAfter} = resolveDiffCurrency(detail);
    const currencies = {currency, currencyBefore, currencyAfter};

    const fields = orderDiffFields(detail, BU_DIFF_FIELD_ORDER)
        .filter(field => !HIDDEN_FIELDS.has(field) && isFieldDiff(detail[field]));
    const extras = extraFieldsSummary(detail, t, fields);
    if (!fields.length && !extras) return null;

    return (
        <React.Fragment>
            {fields.length === 1
                ? <DiffStory field={fields[0]} change={detail[fields[0]]} {...currencies}/>
                : <DiffList changes={detail} fieldOrder={fields} {...currencies}/>}
            <DetailFooter>{extras}</DetailFooter>
        </React.Fragment>
    );
}

// Título de la fila: description del backend + "· N cambios".
export function getFlatDiffTitle(entry, t) {
    return buildChangeCountTitle(entry, t, entry ? entry.detail : null);
}
